import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {ProvidersBrowserSimple} from "../../../shared/providers/ProvidersBrowserSimple";
import Checkbox from "@material-ui/core/Checkbox";
import {NavigationProps, WizardNavigation} from "../../../../_shared/wizard/WizardNavigation";
import {Provider} from "../../../../../models/pro-guest.models";

interface Props extends NavigationProps {
    organizationId: number,
    folderId: number,
    guestsCount: number,
    onChangeProviderSelection: (provider: Provider[]) => void
}

export const Step2Providers: React.FC<Props> = ({organizationId, folderId, guestsCount, onChangeProviderSelection, ...props}) => {
    const {t} = useTranslation();
    const [selectedProviders, setSelectedProviders] = useState<Map<number, Provider>>(new Map());

    const updateProviderChecked = (oldSet: Map<number, Provider>, provider: Provider, checked: boolean): Map<number, Provider> => {
        const newSet = new Map(oldSet);
        if (checked) newSet.set(provider.id, provider);
        else if (!checked && newSet.has(provider.id)) newSet.delete(provider.id);
        return newSet;
    }

    const onProviderChecked = (provider: Provider, e: any) => {
        const checked = e.target.checked;
        setSelectedProviders(oldSet => updateProviderChecked(oldSet, provider, checked));
    };

    const selectProAction = (provider: Provider) => <Checkbox
        checked={selectedProviders.has(provider.id)}
        onChange={e => onProviderChecked(provider, e)}
        color="primary"
        inputProps={{'aria-label': 'primary checkbox'}}
    />;

    const onSubmitChange = (changeTab: () => void) => {
        onChangeProviderSelection(Array.from(selectedProviders, ([id, provider]) => ({...provider})));
        changeTab();
    }

    return <Grid container spacing={3}>
        {<Grid item xs={12}>
            <Typography variant="body1">{t('ProGuest.Groups.Tabs.Providers.Description')}</Typography>
        </Grid>}

        <Grid item xs={12}>
            <ProvidersBrowserSimple organizationId={organizationId}
                                    folderId={folderId}
                                    action={selectProAction}
                                    isFolderProviderSearch={true}
            />
        </Grid>

        <WizardNavigation {...props} onSubmitChange={onSubmitChange}/>
    </Grid>
}
